<template>
  <div>
    <template v-if="hasCalculatedCareLevel">
      <Copy :staticClass="`${className}__careLevelBarHeadline`" size="l" bold element="div">
        {{ $t('cs.analysis.careLevelBar.double.headline') }}
      </Copy>
      <Row>
        <Col :class="`${className}__careLevelBarCol`" :xs="12" :l="6" hasMargin>
          <Label
            v-if="!usingRealCareLevel"
            :label="$t('cs.analysis.careLevelBar.double.selection')"
            :class="`${className}__careLevelBarLabel`"
            color="supportSuccess"
            bold
            size="m"
          />
          <CareLevelBar
            :headline="$t(`cs.analysis.careLevelBar.calculated.headline`)"
            :subline="
              $t(`cs.analysis.careLevelBar.copy.error`, { date: formatDate(calculatedCareLevelAt) })
            "
            :careLevel="calculatedCareLevel"
            careLevelColor="primaryCoral"
            light
            :class="{
              [`${className}__careLevelBar`]: true,
              [`${className}__careLevelBar--clickable`]: true,
              [`${className}__careLevelBar--active`]: !usingRealCareLevel,
            }"
            @click="onClick(false)"
          />
        </Col>
        <Col :class="`${className}__careLevelBarCol`" :xs="12" :l="6" hasMargin>
          <Label
            v-if="usingRealCareLevel"
            :label="$t('cs.analysis.careLevelBar.double.selection')"
            :class="`${className}__careLevelBarLabel`"
            color="supportSuccess"
            bold
            size="m"
          />
          <CareLevelBar
            :headline="$t(`cs.analysis.careLevelBar.headline`)"
            :subline="
              careLevelDate
                ? $t(`cs.analysis.careLevelBar.copy`, { date: formatDate(careLevelDate) })
                : $t(`cs.analysis.careLevelBar.copy.noDate`)
            "
            :careLevel="careLevel"
            careLevelColor="secondaryMintLight"
            :class="{
              [`${className}__careLevelBar`]: true,
              [`${className}__careLevelBar--clickable`]: true,
              [`${className}__careLevelBar--active`]: usingRealCareLevel,
            }"
            @click="onClick(true)"
          />
        </Col>
      </Row>
      <div :class="`${className}__careLevelBarToggle`">
        <ToggleSwitch
          :activeLabel="$t('cs.analysis.careLevelBar.double.toggle.active')"
          :inactiveLabel="$t('cs.analysis.careLevelBar.double.toggle.inactive')"
          :checked="usingRealCareLevel"
          @click="onClick(!usingRealCareLevel)"
        />
      </div>
    </template>
    <CareLevelBar
      v-else
      :headline="$t(`cs.analysis.careLevelBar.headline`)"
      :subline="
        careLevelDate
          ? $t(`cs.analysis.careLevelBar.copy`, { date: formatDate(careLevelDate) })
          : $t(`cs.analysis.careLevelBar.copy.noDate`)
      "
      :careLevel="careLevel"
      careLevelColor="secondaryMintLight"
    />
  </div>
</template>

<script>
import ToggleSwitch from '@/objects/ToggleSwitch';
import Label from '@/objects/Label';
import Copy from '@/objects/Copy';
import Row from '@/components/Grid/Row';
import CareLevelBar from '@/components/CareLevelBar';
import Col from '@/components/Grid/Col';

import mixinCareService from '@/mixins/careService';
import mixinCareLevel from '@/mixins/careLevel';

import { CARESERVICE_UPDATE_CARELEVEL } from '@/store/actions/careService';
import { formatDate } from '@/helpers/formatter';

export default {
  components: {
    Copy,
    Label,
    Row,
    CareLevelBar,
    Col,
    ToggleSwitch,
  },
  mixins: [mixinCareService, mixinCareLevel],
  props: {
    className: String,
  },
  data() {
    return {
      formatDate,
      usingRealCareLevel: true,
    };
  },
  computed: {
    hasCalculatedCareLevel() {
      return !!this.calculatedCareLevel && this.calculatedCareLevel > this.careLevel;
    },
  },
  methods: {
    onClick(usingRealCareLevel) {
      this.usingRealCareLevel = usingRealCareLevel;

      this.$store.dispatch(CARESERVICE_UPDATE_CARELEVEL, {
        careServiceCareLevel: this.usingRealCareLevel ? this.careLevel : this.calculatedCareLevel,
      });
    },
  },
};
</script>
